module.exports = __webpack_public_path__ + "media/1.2b48bee8.mp4";